module.exports = __webpack_public_path__ + "dist/assets/img/raspberry.e01df576.svg";